export interface Product {
  id: string;
  name: string;
  categoryId: string;
  price: number;
  originalPrice: number;
  unit: string;
  image: string;
  description: string;
  features: string[];
  stock: number;
  sales: number;
  rating: number;
  origin: string;
  weight: string;
}

export const products: Product[] = [
  {
    id: 'p001',
    name: '阳山特级水蜜桃礼盒',
    categoryId: 'premium-gift',
    price: 298,
    originalPrice: 398,
    unit: '盒',
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20gift%20box%20of%20premium%20ripe%20peaches%20with%20velvety%20pink%20skin%2C%20arranged%20elegantly%20in%20a%20wooden%20gift%20box%20with%20silk%20lining%2C%20soft%20natural%20lighting%2C%20warm%20cream%20background%2C%20minimalist%20product%20photography%20style%2C%20high%20detail%2C%20clean%20composition&width=800&height=800&seq=peach-gift-01&orientation=squarish',
    description: '精选阳山核心产区特级水蜜桃，每颗重约250g以上，果形端正饱满，色泽红润诱人。精美木质礼盒包装，含6颗精品桃，是送礼的上佳之选。',
    features: ['阳山核心产区', '单果250g+', '6颗礼盒装', '精美木质礼盒', '顺丰冷链直达'],
    stock: 200,
    sales: 1865,
    rating: 4.9,
    origin: '江苏无锡阳山',
    weight: '约1.5kg/盒',
  },
  {
    id: 'p002',
    name: '龙泉驿水蜜桃臻选礼盒',
    categoryId: 'premium-gift',
    price: 258,
    originalPrice: 328,
    unit: '盒',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20gift%20box%20of%20large%20juicy%20pink%20peaches%20with%20dew%20drops%2C%20arranged%20in%20a%20premium%20cardboard%20gift%20box%20with%20gold%20accents%2C%20natural%20window%20light%2C%20cream%20backdrop%2C%20food%20photography%2C%20high%20resolution%2C%20clean%20minimal%20aesthetic&width=800&height=800&seq=peach-gift-02&orientation=squarish',
    description: '四川龙泉驿产区优质水蜜桃，果肉细腻柔软，汁水丰沛甜蜜。礼盒含8颗精选桃，搭配精美手提袋，送礼自用两相宜。',
    features: ['龙泉驿产区', '单果200g+', '8颗礼盒装', '精美手提袋', '顺丰冷链直达'],
    stock: 150,
    sales: 1320,
    rating: 4.8,
    origin: '四川成都龙泉驿',
    weight: '约1.6kg/盒',
  },
  {
    id: 'p003',
    name: '奉化玉露水蜜桃礼盒',
    categoryId: 'premium-gift',
    price: 328,
    originalPrice: 428,
    unit: '盒',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Fenghua%20honey%20peaches%20in%20a%20beautiful%20bamboo%20gift%20basket%2C%20ripe%20peaches%20with%20blush%20pink%20skin%20and%20green%20leaves%2C%20soft%20diffused%20lighting%2C%20light%20beige%20background%2C%20artisan%20food%20photography%2C%20elegant%20composition&width=800&height=800&seq=peach-gift-03&orientation=squarish',
    description: '奉化玉露水蜜桃，皮薄如纸，汁多味甜，被誉为"琼浆玉露"。甄选最高品质玉露桃，竹编礼篮装，体现传统与品质的完美结合。',
    features: ['奉化核心产区', '玉露品种', '单果220g+', '竹编礼篮装', '顺丰冷链直达'],
    stock: 80,
    sales: 956,
    rating: 4.9,
    origin: '浙江宁波奉化',
    weight: '约1.4kg/篮',
  },
  {
    id: 'p004',
    name: '阳山新鲜水蜜桃 家庭装',
    categoryId: 'fresh-pick',
    price: 168,
    originalPrice: 218,
    unit: '箱',
    image: 'https://readdy.ai/api/search-image?query=Freshly%20picked%20ripe%20peaches%20in%20a%20cardboard%20box%20with%20green%20leaves%2C%20dewdrops%20on%20the%20fuzzy%20skin%2C%20natural%20morning%20light%2C%20rustic%20wooden%20table%20surface%2C%20farm%20fresh%20aesthetic%2C%20warm%20natural%20tones%2C%20high%20detail%20food%20photography&width=800&height=800&seq=peach-fresh-01&orientation=squarish',
    description: '清晨采摘当日发货的阳山水蜜桃，保证最佳新鲜度。家庭装12颗，适合与家人分享这份来自大自然的甜蜜。',
    features: ['当日采摘', '家庭分享装', '12颗装', '经济实惠', '顺丰速运'],
    stock: 500,
    sales: 3420,
    rating: 4.7,
    origin: '江苏无锡阳山',
    weight: '约2.5kg/箱',
  },
  {
    id: 'p005',
    name: '龙泉驿新鲜水蜜桃 尝鲜装',
    categoryId: 'fresh-pick',
    price: 98,
    originalPrice: 128,
    unit: '箱',
    image: 'https://readdy.ai/api/search-image?query=Six%20fresh%20organic%20peaches%20with%20fuzzy%20skin%20and%20pink%20blush%20in%20a%20simple%20kraft%20paper%20box%2C%20some%20with%20leaves%20attached%2C%20natural%20daylight%2C%20clean%20white%20surface%2C%20fresh%20farm%20produce%20photography%2C%20bright%20and%20airy&width=800&height=800&seq=peach-fresh-02&orientation=squarish',
    description: '初次品尝龙泉驿水蜜桃的绝佳选择，6颗尝鲜装，口感鲜嫩多汁、甜蜜清香，带您领略四川水蜜桃的独特风味。',
    features: ['尝鲜首选', '6颗装', '高性价比', '龙泉驿产地', '顺丰速运'],
    stock: 600,
    sales: 5120,
    rating: 4.6,
    origin: '四川成都龙泉驿',
    weight: '约1.2kg/箱',
  },
  {
    id: 'p006',
    name: '奉化新鲜玉露水蜜桃',
    categoryId: 'fresh-pick',
    price: 198,
    originalPrice: 258,
    unit: '箱',
    image: 'https://readdy.ai/api/search-image?query=Ripe%20Fenghua%20jade%20dew%20peaches%20with%20extremely%20thin%20skin%20and%20intense%20blush%20color%2C%20arranged%20in%20a%20stylish%20paper%20box%2C%20soft%20golden%20hour%20lighting%2C%20cream%20linen%20background%2C%20premium%20food%20photography%2C%20luscious%20and%20appetizing&width=800&height=800&seq=peach-fresh-03&orientation=squarish',
    description: '正宗奉化玉露水蜜桃，皮薄肉嫩、汁水丰沛。10颗家庭装，每一口都是最纯正的蜜桃风味，让你回味无穷。',
    features: ['奉化玉露品种', '10颗装', '皮薄汁多', '甜度高', '顺丰速运'],
    stock: 300,
    sales: 2340,
    rating: 4.8,
    origin: '浙江宁波奉化',
    weight: '约2.0kg/箱',
  },
  {
    id: 'p007',
    name: '臻品蜜桃综合礼篮',
    categoryId: 'fruit-basket',
    price: 398,
    originalPrice: 528,
    unit: '篮',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20wicker%20basket%20filled%20with%20assorted%20premium%20peaches%20of%20different%20varieties%2C%20some%20pink%20some%20yellow%2C%20decorated%20with%20dried%20flowers%20and%20ribbon%2C%20warm%20natural%20light%2C%20cream%20background%2C%20luxury%20gift%20presentation%2C%20detailed%20composition&width=800&height=800&seq=peach-basket-01&orientation=squarish',
    description: '汇集三大产区精品水蜜桃，阳山、龙泉驿、奉化一篮尽享。搭配精选时令水果，丰富口感层次，是高端送礼的极致之选。',
    features: ['三大产区精选', '多品种搭配', '装饰精致', '高端送礼首选', '顺丰冷链直达'],
    stock: 60,
    sales: 720,
    rating: 5.0,
    origin: '多产区精选',
    weight: '约3.0kg/篮',
  },
  {
    id: 'p008',
    name: '甜蜜家庭水果篮',
    categoryId: 'fruit-basket',
    price: 258,
    originalPrice: 338,
    unit: '篮',
    image: 'https://readdy.ai/api/search-image?query=A%20charming%20woven%20basket%20with%20fresh%20peaches%20and%20assorted%20seasonal%20fruits%2C%20bright%20and%20colorful%20arrangement%2C%20natural%20daylight%2C%20warm%20kitchen%20setting%2C%20homestyle%20food%20photography%2C%20inviting%20and%20fresh%20composition&width=800&height=800&seq=peach-basket-02&orientation=squarish',
    description: '温馨家庭水果篮，水蜜桃搭配时令鲜果，满足全家人的口味需求。精巧编织篮装，既是美味也是装饰。',
    features: ['水蜜桃+时令水果', '家庭分享装', '精巧编织篮', '性价比之选', '顺丰速运'],
    stock: 120,
    sales: 1680,
    rating: 4.7,
    origin: '多产区精选',
    weight: '约2.5kg/篮',
  },
  {
    id: 'p009',
    name: '白凤水蜜桃 时令限定',
    categoryId: 'seasonal',
    price: 358,
    originalPrice: 468,
    unit: '盒',
    image: 'https://readdy.ai/api/search-image?query=Rare%20white%20phoenix%20peach%20variety%20with%20pale%20cream%20skin%20and%20subtle%20pink%20blush%2C%20displayed%20in%20a%20minimal%20white%20ceramic%20plate%2C%20soft%20natural%20light%2C%20elegant%20cream%20background%2C%20fine%20art%20food%20photography%2C%20delicate%20and%20refined&width=800&height=800&seq=peach-season-01&orientation=squarish',
    description: '稀有白凤品种水蜜桃，果肉洁白如玉，口感细腻绵密，甜度极高。每年仅7月中下旬上市，数量极为有限，错过再等一年。',
    features: ['白凤稀有品种', '限量发售', '果肉洁白如玉', '甜度极高', '顺丰冷链空运'],
    stock: 40,
    sales: 380,
    rating: 5.0,
    origin: '江苏无锡阳山',
    weight: '约1.2kg/盒',
  },
  {
    id: 'p010',
    name: '黄桃蜜语 时令限定',
    categoryId: 'seasonal',
    price: 228,
    originalPrice: 298,
    unit: '盒',
    image: 'https://readdy.ai/api/search-image?query=Golden%20yellow%20peaches%20with%20a%20warm%20amber%20glow%2C%20arranged%20artistically%20on%20a%20dark%20wooden%20board%2C%20warm%20side%20lighting%2C%20cream%20background%2C%20rustic%20elegant%20food%20photography%2C%20rich%20golden%20tones&width=800&height=800&seq=peach-season-02&orientation=squarish',
    description: '精选优质黄桃，果肉金黄饱满，口感香甜软糯。每年8月限定上市，是不可错过的时令美味。适合鲜食或制作甜品。',
    features: ['优质黄桃品种', '时令限定', '果肉金黄', '香甜软糯', '顺丰冷链直达'],
    stock: 80,
    sales: 650,
    rating: 4.8,
    origin: '安徽砀山',
    weight: '约1.5kg/盒',
  },
];